import React, { useEffect } from 'react';
import UserLayoutTop from './user-layout-top';
import UserLayoutSideDynamic from './user-layout-side/user-layout-side-dynamic';
import { useDssContext } from '../../../DSSContext';
import { MENUPOSITION } from '../../dashboard/model';

export const UserLayoutDynamic = () => {
  const { menuPosition, setMenuPosition } = useDssContext();
  useEffect(() => {
    setMenuPosition(MENUPOSITION.VERTICAL);
  }, []);

  return (
    <>
      {menuPosition === MENUPOSITION.HORIZONTAL ? (
        <UserLayoutTop />
      ) : (
        <UserLayoutSideDynamic />
      )}
    </>
  );
};

export default UserLayoutDynamic;
